import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { BoxIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';

interface OrdersInQueueProps {
  count: number;
  isInCheetahsMobileGigPage?: boolean;
}

export function OrdersInQueue({ count, isInCheetahsMobileGigPage = false }: OrdersInQueueProps) {
  const label = <I18n k="gig_page_perseus.overview.orders_in_queue_single_plural" params={{ count }} />;

  if (isInCheetahsMobileGigPage) {
    return (
      <Stack gap="2" alignItems="center" width="auto">
        <BoxIcon size="md" color="grey_1200" />
        <Text size="b_sm" fontWeight="semibold">
          {label}
        </Text>
      </Stack>
    );
  }

  return <Text color="bodySecondary">{label}</Text>;
}
